import angular from 'angular';
import constants from 'app/constants/index';
import { focus } from 'app/services/index';
import controller from './process-recovery-function.controller';
import directive from './process-recovery-function.directive';


export default angular.module('app.components.advisory.bcp.processRecoveryFunction', [
  constants,
  focus
])
  .directive('bcpProcessRecoveryFunction', directive)
  .controller('ProcessRecoveryFunctionController', controller)
  .name;

console.log('app.components.advisory.bcp.processRecoveryFunction created');
